import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { Spinner, Tab, TabList, SelectTabData, SelectTabEvent, Subtitle1 } from '@fluentui/react-components';

// functions
import * as ComponentFunctions from './ProtocolContract.Functions';

// i18n
import { useTranslation } from 'react-i18next';

// Styles
import './ProtocolContract.Styles.css';
import { ChevronRightRegular } from '@fluentui/react-icons';

export const ProtocolContractTabComponent = (props: ComponentFunctions.Props) => {
    const [t] = useTranslation();
    const [selectedTab, setSelectedTab] = useState<string>('');

    useEffect(() => {
        if (props.ContractAssociation != undefined) {
            props.GetAllProtocolContractAssociations(props.ProtocolId);
        }
    }, [props.ProtocolId, props.ContractAssociation !== undefined]);

    useEffect(() => {
        if (props.ContractAssociation?.contractId && !props.AssociatedContract) {
            props.GetContractById(props.ContractAssociation.contractId);
        }
    }, [props.ContractAssociation?.contractId]);

    useEffect(() => {
        if (props.AssociatedContract && selectedTab === '') {
            setSelectedTab(props.AssociatedContract.id.toString());
        }
    }, [props.AssociatedContract]);

    const onTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
        setSelectedTab(data.value as string);
    };

    if (props.isLoading) {
        return (
            <div className='UnsectionTab protocolContractTab'>
                <Subtitle1><ChevronRightRegular />&nbsp;Contratos Asociados</Subtitle1>
                <Spinner
                    size='extra-small'
                    label={t('protocolContractTab.loading', 'Cargando contratos...')}
                    className='tabSpinner'
                />
            </div>
        );
    }

    if (!props.ContractAssociation) {
        return (
            <div className='UnsectionTab protocolContractTab'>
                <Subtitle1><ChevronRightRegular />&nbsp;Contratos Asociados</Subtitle1>
                <span className='noContractMessage'>
                    {t('protocolContractTab.noContract', 'No hay contratos asociados')}
                </span>
            </div>
        );
    }

    return (
        <div className='UnsectionTab protocolContractTab'>
            <Subtitle1><ChevronRightRegular />&nbsp;Contratos Asociados</Subtitle1>
            <TabList selectedValue={selectedTab} onTabSelect={onTabSelect}>
                {props.AssociatedContract ? (
                    <Tab
                        key={props.AssociatedContract.id}
                        value={props.AssociatedContract.id.toString()}
                    >
                        {props.AssociatedContract.contractNumber}
                    </Tab>
                ) : (
                    <Tab
                        key={props.ContractAssociation.contractId}
                        value={props.ContractAssociation.contractId.toString()}
                    >
                        <Spinner size='tiny' />
                    </Tab>
                )}
            </TabList>
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ProtocolContractTabComponent as any);
